// src/components/LanguageSwitcher.js
import React from 'react';
import { ToggleButton, ToggleButtonGroup } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useTheme } from '@mui/material/styles';

const LanguageSwitcher = () => {
  const { i18n } = useTranslation();
  const { t } = useTranslation();
  const currentLanguage = i18n.language || 'en';
  const theme = useTheme();

  const handleLanguageChange = (event, newLang) => {
    if (newLang) {
      i18n.changeLanguage(newLang);
      localStorage.setItem('language', newLang);
    }
  };

  return (
    <ToggleButtonGroup
      value={currentLanguage}
      exclusive
      onChange={handleLanguageChange}
      aria-label={t('common.language')}
      size="small"
      color="primary"
      sx={{
        backgroundColor: 'transparent',
        border: 'none',
        '& .MuiToggleButton-root': {
          textTransform: 'none',
          fontWeight: 'bold',
          px: 1.1,
          borderColor: 'divider',
          color: 'text.secondary',
          backgroundColor: theme.palette.mode === 'dark' ? 'rgba(8, 15, 28, 0.5)' : 'rgba(255,255,255,0.65)',
        },
        '& .Mui-selected': {
          color: 'text.primary',
        },
      }}
    >
      <ToggleButton value="en" aria-label={t('common.english')}>
        <span role="img" aria-label={t('common.english')} style={{ marginRight: 4 }}>🇺🇸</span> {t('common.english')}
      </ToggleButton>
      <ToggleButton value="gr" aria-label={t('common.greek')}>
        <span role="img" aria-label={t('common.greek')} style={{ marginRight: 4 }}>🇬🇷</span> {t('common.greek')}
      </ToggleButton>
    </ToggleButtonGroup>
  );
};

export default LanguageSwitcher;
